import { useEffect } from 'react';
import styled from 'styled-components';
import { Button, Card } from '../../ui/ot';

// 外層容器
const Container = styled.div`
  max-width: 560px;
  margin: 0 auto;
  padding: 4rem 1.5rem;
  font-family: 'Segoe UI', sans-serif;
`;

// 頁面標題與副標題
const Header = styled.header`
  text-align: center;
  margin-bottom: 2.5rem;

  h1 {
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 0.75rem;
    color: #1f2937;
  }

  p {
    font-size: 0.95rem;
    color: #6b7280;
    line-height: 1.6;
  }
`;

// 卡片樣式
const StyledCard = styled(Card)`
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 10px 20px rgba(0,0,0,0.05);
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

// 資訊列表
const InfoList = styled.ul`
  padding-left: 1.25rem;
  font-size: 0.9rem;
  color: #4b5563;
  list-style-type: disc;
  line-height: 1.8;
`;

// 更新資訊
const UpdateInfo = styled.div`
  font-size: 0.85rem;
  color: #9ca3af;
  text-align: center;
`;

// 下載按鈕連結
const DownloadLink = styled.a`
  width: 100%;
  text-decoration: none;
`;

// 按鈕樣式（覆蓋 UI 套件按鈕風格）
const StyledButton = styled.button`
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  border-radius: 0.75rem;
  font-weight: 500;
  transition: all 0.2s ease;
  background-color:#ffe4c4;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 14px rgba(0,0,0,0.08);
  }
`;

const FormDownload = ({ prefixTitle }) => {
    useEffect(() => {
        document.title = `${prefixTitle} | 借書證申請表下載`;
    }, [prefixTitle]);

    return (
        <Container>
            <Header>
                <h1>借書證申請表下載</h1>
                <p>
                    此表單適用於申請本圖書自動化系統的借書證。<br />
                    請下載後完整填寫。
                </p>
            </Header>

            <StyledCard>
                <InfoList>
                    {/* <li>包含自動計算欄位，填寫更快速</li> */}
                    <li>格式符合圖書系統匯入標準</li>
                    {/* <li>檔案大小：245KB（.xlsx）</li> */}
                </InfoList>
                <UpdateInfo>最後更新：2024-03-31</UpdateInfo>
                <DownloadLink href="/借書證申請表.xlsx" download>
                    <StyledButton>
                        📥 下載 Excel 表單
                    </StyledButton>
                </DownloadLink>
            </StyledCard>
        </Container>
    );
};

export default FormDownload;
